import DynamicReportCategoryModel from "@/models/DynamicReportCategoryModel";

export default class DynamicReportCategoriesState {
  dynamicCategories?: DynamicReportCategoryModel[];
  loaded = false;
}
